import React, { FC, SVGProps } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const BadgeCheckIcon: FC<SVGComponentProps & SVGProps<SVGSVGElement>> = ({
  width = 48,
  height = 48
}) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="m44.62 19.52-2-1.52c.26-.92.48-1.7.68-2.38.8-2.68 1.24-4.16.14-5.68S40.84 8.36 38 8.28h-2.48c-.34-.88-.6-1.66-.84-2.34-.92-2.64-1.44-4-3.22-4.66s-3.06.28-5.38 1.88l-2 1.38-2-1.34C20 1.58 18.48.58 16.66 1.18s-2.3 2-3.24 4.66c-.24.66-.5 1.44-.84 2.32l-2.58.1c-2.8 0-4.34.1-5.44 1.62s-.56 3 .2 5.7c.2.68.44 1.46.68 2.38l-2 1.52C1.28 21.16 0 22.1 0 24s1.22 2.82 3.44 4.52l2 1.52c-.24.92-.48 1.7-.68 2.38-.8 2.68-1.24 4.16-.14 5.68s2.66 1.56 5.44 1.64h2.46c.34.88.6 1.66.84 2.34.92 2.64 1.44 4 3.24 4.68s3.06-.3 5.38-1.88l2-1.38 2 1.34a8.4 8.4 0 0 0 4.38 2c.36-.004.718-.065 1.06-.18 1.8-.58 2.3-2 3.24-4.66.24-.66.5-1.44.84-2.34h2.48c2.8 0 4.34-.1 5.44-1.62s.68-3-.12-5.68c-.2-.68-.44-1.46-.68-2.38l2-1.52C46.82 26.86 48 26 48 24s-1.16-2.78-3.38-4.48"
        fill="#2db674"
      />
      <path
        d="M20.76 34.52a2 2 0 0 1-1.42-.68l-5.92-6.58a2.005 2.005 0 1 1 3-2.66l4.44 5.02L33.5 17.3a2.002 2.002 0 0 1 2.8 2.86L22.16 34a2 2 0 0 1-1.4.52"
        fill="#fff"
      />
    </svg>
  </SVGUniqueID>
);

export { BadgeCheckIcon };
